import React from 'react';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { WithApp } from 'contexts/appContext';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Add, Close } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';

import Modal from './Modal/MarkModal';
import { useModal } from 'hooks/useModal';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function Mark(props) {
  const classes = useStyles();
  const { businessPartner, showNotify, confirmDelete, reload } = props;
  const [model, setOpen] = useModal(); //uso de las funciones del modal

  return (
    <>
      <Modal
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={reload}
        businessPartnerId={businessPartner.id}
        marks={businessPartner.marks}
      />
      <Card>
        <CardHeader icon>
          <CardIcon
            onClick={() => setOpen({})}
            pointer="true"
            color={props.themeContext.buttonColorSuccess}
          >
            <Add />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de marcas</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName={'Marcas-proveedor-' + businessPartner.CardCode}
            defaultWidth={1200}
            indexRow={[0, 4]}
            widthRow={[100, 0]}
            columns={columns}
            data={
              businessPartner.marks?.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <Button
                        justIcon
                        round
                        simple
                        onClick={() => {
                          confirmDelete(
                            'base/business-partner/' + businessPartner.id + '/mark/' + item.id
                          );
                        }}
                        color={props.themeContext.buttonColorDanger}
                        className="remove"
                      >
                        <Close />
                      </Button>
                    </div>
                  ),
                  code: item.code,
                  description: item.description,
                  state: item.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: ''
                };
              }) || []
            }
          />
        </CardBody>
      </Card>
    </>
  );
});
